import { styled } from 'styled-components';
import { IGlobaVariables } from '../../../components/Layout/styles';

import { ICategoriesSide1, defaultParams } from './params';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  $config: ICategoriesSide1;
  $activeCategoryClickable: boolean;
}>`
  .categories-side {
    padding: 0 0 45px;

    &-header {
      color: ${({ $config: styles }) => styles.group_header.color};
      font-family: ${({ $config: styles }) => styles.group_header.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_header.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_header.fontSize};
      line-height: ${({ $config: styles }) => styles.group_header.lineHeight};
      border-bottom: ${({ $config: styles }) => styles.group_header.borderBottom};
      text-align: ${({ $config: styles }) => styles.group_header.textAlign};
      padding-bottom: ${({ $config: styles }) => (styles.group_header.borderBottom === 'none' ? 0 : '12px')};
      margin-bottom: 30px;
    }

    &-wrapper {
      display: grid;
      grid-template-columns: 1fr;
      gap: 15px;
    }

    &-category {
      color: ${({ $config: styles }) => styles.group_category.color};
      font-family: ${({ $config: styles }) => styles.group_category.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_category.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_category.fontSize};
      line-height: ${({ $config: styles }) => styles.group_category.lineHeight};
      text-decoration: ${({ $config: styles }) => styles.group_category.textDecoration};
      font-style: ${({ $config: styles }) => styles.group_category.fontStyle};
      transition: color 0.3s ease-in-out;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 7px;
      svg {
        height: ${({ $config: styles }) => styles.group_category.group_arrow.height};
        color: ${({ $config: styles }) => styles.group_category.group_arrow.color};
      }
      &:hover {
        color: ${({ $config: styles }) => styles.group_category.hover_color};
        text-decoration: ${({ $config: styles }) => styles.group_category.hover_textDecoration};
        svg {
          color: ${({ $config: styles }) => styles.group_category.group_arrow.hover_color};
        }
      }
      &.active {
        pointer-events: ${({ $activeCategoryClickable }) => ($activeCategoryClickable ? 'auto' : 'none')};
        padding: 5px 7px 5px 7px;
        background: ${({ $config: styles }) => styles.group_category_active.backgroundColor};
        color: ${({ $config: styles }) => styles.group_category_active.color};
        text-decoration: ${({ $config: styles }) => styles.group_category_active.textDecoration};
        border-radius: ${({ $config: styles }) => styles.group_category_active.borderRadius};
        &:hover {
          text-decoration: ${({ $config: styles, $activeCategoryClickable }) =>
            $activeCategoryClickable
              ? styles.group_category.hover_textDecoration
              : styles.group_category_active.textDecoration};
        }
        svg {
          color: ${({ $config: styles }) => styles.group_category_active.group_arrow.color};
        }
      }
    }
  }
`;

export default Styles;
